export default __webpack_public_path__ + "static/media/doc.d6d6e78d.svg";